import { EnterpretLogoIcon } from '@modules/common/components/EnterpretLogoIcon';
import { IntegrationSource } from '@modules/integrationsV2/types';
import { SwapHorizRounded } from '@mui/icons-material';
import { Box, LinearProgress, Paper, Stack, Typography } from '@mui/material';

interface IntegrationSourceIngestionInProgressCardProps {
  integrationSource: IntegrationSource;
}

export const IntegrationSourceIngestionInProgressCard = ({
  integrationSource,
}: IntegrationSourceIngestionInProgressCardProps) => {
  return (
    <Stack alignItems="center" justifyContent="center" pt={10}>
      <Paper
        variant="outlined"
        sx={{
          maxWidth: 500,
          p: 3,
          textAlign: 'center',
        }}
      >
        <Stack alignItems="center" spacing={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={2}
          >
            <Box
              width="36px"
              component="img"
              alignSelf="center"
              src={integrationSource.channel.logo}
              alt={integrationSource.channel.displayName}
            />
            <SwapHorizRounded
              sx={{
                fontSize: '36px',
                color: 'text.disabled',
              }}
            />
            <EnterpretLogoIcon width="36" height="36" />
          </Stack>
          <LinearProgress
            sx={{
              width: '80%',
              height: '14px',
              borderRadius: 3,
            }}
            color="primary"
            variant="determinate"
            value={integrationSource.onboardingProgress}
          />
          <Typography color="info.main">
            Data ingestion in progress. This may take up to 24 hours.
          </Typography>
          {/* TODO: Uncomment when notifications are ready */}
          {/* <Divider
            sx={{
              width: '80%',
            }}
          /> */}
          {/* <Box>
            <Typography>
              We'll send a notification 🔔 and an email 📩
            </Typography>
            <Typography>when the ingestion is complete!</Typography>
          </Box> */}
        </Stack>
      </Paper>
    </Stack>
  );
};
